<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Contactgegevens
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als de Belastingdienst vragen/opmerkingen heeft over de aangifte, dan kan er contact worden opgenomen
                met een contactpersoon. De 'Contactpersoon' bevat de gegevens over de
                persoon waarmee contact gezocht kan worden. De ontvanger, schenker, aangever of iemand anders kan
                optreden als contactpersoon (bijv. het advieskantoor). De contactpersoon is een natuurlijk persoon.
                <div class="space20"></div>
                Vul de gegevens in (aan):<br>
                <ul>
                    <li>naam: vermeld de naam (voorlettters, evt. tussenvoegsel(s) en achternaam) van de contactpersoon
                in.</li>
                    <li>e-mailadres: het e-mailadres waar de Belastingdienst een reactie heen kan sturen.</li>
                    <li>telefoonnummer: het telefoonnummer waar de Belastingdienst naar toe kan bellen.</li>
                <li>beconnummer: het beconnummer is het registratienummer dat je bij de Belastingdienst kunt aanvragen als kantoor.</li>
                <li>burgerservicenummer: als er geen beconnummer is, vul dan het BSN van de persoon die als contactpersoon is aangemerkt.</li>
                </ul>
                <b>N.b. Let er op dat je niet zowel een beconnummer als een burgerservicenummer invult!</b>
            </div>
        </div>
    </div>
</div>
